import { WarningIcon } from '@assets/svgs/WarningIcon'

import * as S from './styles'

export const ConsolidatedEditAlert = () => {
  return (
    <S.Container>
      <WarningIcon />
      <S.Text>
        Esta tela é exclusiva para unidades que não pertencem ao segmento Food/Corporate. Unidades Food/Corporate
        possuem acesso somente para visualização.
      </S.Text>
    </S.Container>
  )
}
